/**
 * 설정 관련 상태 관리 store
 * @author Ju
 */
const settings = {
  state: {
    autoMoveMenuInfo: null,
    /**
     * 네트워크 모델링 결과 강제 로드 여부
     * true일 경우 초기 설정 > 장비 등록 > 네트워크 > 관리 대상 목록을 로드한다.
     * @type {Boolean}
     */
    forceNetworkModelingResultLoad: false,
  },
  mutations: {
    /**
     * 자동으로  이동할 설정 메뉴 정보를 설정한다.
     * @author Ju
     * @param  {object} state
     * @param  {array} menuInfo 이동할 메뉴 배열
     */
    setAutoMoveMenuInfo: (state, menuInfo) => {
      state.autoMoveMenuInfo = menuInfo;
    },
    /**
     * 네트워크 모델링 결과 강제 로드 여부를 설정한다.
     * @author Ju
     * @param  {object} state   [description]
     * @param  {boolean} loading 강제 로드 여부
     */
    setForceNetworkModelingResultLoad: (state, loading) => {
      state.forceNetworkModelingResultLoad = loading;
    },
  },
  actions: {
    /**
     * 자동으로  이동할 설정 메뉴 정보를 설정한다.
     * @author Ju
     * @param  {object} commit
     * @param  {array} menuInfo 이동할 메뉴 배열
     */
    setAutoMoveMenuInfo({ commit }, menuInfo) {
      commit('setAutoMoveMenuInfo', menuInfo);
    },
    /**
     * 네트워크 모델링 결과 강제 로드 여부를 설정한다.
     * @author Ju
     * @param  {object} commit   [description]
     * @param  {boolean} loading 강제 로드 여부
     */
    setForceNetworkModelingResultLoad({ commit }, loading) {
      commit('setForceNetworkModelingResultLoad', loading);
    },
  },
};

export default settings;



// WEBPACK FOOTER //
// ./src/store/modules/setting.js